// Screens.js
import HomePage from '../../components/HomePage';
import ContactUs from '../../components/ContactUs';
import Video from '../../components/VideosComponents/Video';
import IndividualVideo from '../../components/IndividualVideoComponents/IndividualVideo';
import StageDetails from '../../components/AnimatedComponents/StageDetails';
import NotFound from '../../components/NotFoundComponents/NotFound';
import Blogs from '../Blogs/Blogs';
import IndividualBlog from '../Blog/IndividualBlog';
import AboutUs from '../AboutUs/AboutUs';
import Offerings from '../Offerings/Offerings';
import SuccessStories from '../SuccessStories/SuccessStories';
import Evaluation from '../Evaluation/Evaluation';
import PrivacyPolicy from '../PrivacyPolicy/PrivacyPolicy.jsx';

const Screens = {
  HomePage,
  StageDetails,
  ContactUs,
  Video,
  IndividualVideo,
  NotFound,
  Blogs,
  IndividualBlog,
  AboutUs,
  PrivacyPolicy,
  Offerings,
  SuccessStories,
  Evaluation
};

export default Screens;
